import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import moment from 'moment';
import 'moment/locale/fr';
import { AuthService } from '@shared/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { AUTH_LOGIN_ROUTE } from './app-routing.constants';
import { ASSETS_HTTP_CLIENT } from './app.module';
import { CONFIG, Config } from 'config/config';
import { NgIf } from '@angular/common';
import { HttpLoaderComponent } from '@shared/components/http-loader/http-loader.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, NgIf, HttpLoaderComponent, TranslatePipe],
})
export class AppComponent implements OnInit {
  etag: string | null = null;
  promptNewDashboardDetected: boolean = false;
  currentPath: string = '';

  constructor(
    @Inject(CONFIG) private readonly config: Config,
    private readonly router: Router,
    private readonly auth: AuthService,
    @Inject(ASSETS_HTTP_CLIENT) private readonly http: HttpClient,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPath = event.url;
      }
    });
    moment.locale(this.auth.getCurrentLanguage());
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        console.log('[NavErr] url=', event.url, '| msg=', event.error?.message);
        const msg = event.error?.message ?? '';
        if (
          /Failed to fetch dynamically imported module|ChunkLoadError|error loading dynamically imported module/i.test(
            msg,
          )
        ) {
          window.location.href = window.location.pathname + '#' + event.url;
          window.location.reload();
        }
      }
    });
  }

  ngOnInit() {
    this.scrollTopBetweenNavigation();
    if (this.config.detectVersionChange) {
      this.detectVersionChange();
    }
  }

  scrollTopBetweenNavigation() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  async detectVersionChange() {
    this.getEtag();

    window.addEventListener(
      'visibilitychange',
      (event) => {
        const visibilityState = (event.target as Document).visibilityState;
        if (visibilityState == 'visible') this.getEtag();
      },
      false,
    );
  }

  getEtag() {
    this.http
      .head<any>('/', { observe: 'response', headers: { 'Skip-Loader': 'true', 'Cache-Control': 'no-cache' } })
      .subscribe((res) => {
        const previousEtag = this.etag;
        this.etag = res?.headers?.get('etag');

        if (previousEtag != null && previousEtag != this.etag) {
          if (!this.currentPath || this.currentPath == `/${AUTH_LOGIN_ROUTE}`) {
            this.reload();
          } else {
            this.promptNewDashboardDetected = true;
          }
        }
      });
  }

  reload() {
    window.location.reload();
  }
}
